import { gql } from "@apollo/client";

const YRH_COMMENT_FIELDS = `
  id
  parentId
  authorId
  domain
  isPrivate
  data
  ref {
    collection
    id
  }
  createdAt
  updatedAt
`;

export const GET_YRH_COMMENTS = gql`
  query GetYrhComments($input: YrhCommentsInput!) {
    yrhComments(input: $input) {
      total
      yrhComments {
        ${YRH_COMMENT_FIELDS}
      }
    }
  }
`;
